import script from "./AddProgressButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProgressButton.vue?vue&type=script&setup=true&lang=js"

import "./AddProgressButton.vue?vue&type=style&index=0&id=1fcdb78f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fcdb78f"]])

export default __exports__